import { Button, HStack, useColorModeValue } from '@chakra-ui/react';
import { SITE_NAV_LINK_FONT_SIZE } from './siteNavLayout';
import { SiteNavLinkLabel } from './SiteNavLinkLabel';
import { useSiteNavNavigation } from './useSiteNavNavigation';

export { SITE_NAV_ROUTES } from './siteNavRoutes';

export function SiteNavLinks(props: { fontSize?: number | string }) {
  const { routes, isActive, onNavClick, activeColor, inactiveColor, hoverBg } = useSiteNavNavigation();
  const fontSize = props.fontSize ?? SITE_NAV_LINK_FONT_SIZE;
  const emphasizeColor = useColorModeValue('brandAccent', 'babyBlue');

  const linkProps = {
    variant: 'ghost' as const,
    fontSize,
    _hover: { bg: hoverBg },
  };

  return (
    <HStack spacing={1}>
      {routes.map(({ label, path, badge, emphasize }) => {
        const active = isActive(path);
        return (
          <Button
            key={path}
            {...linkProps}
            fontWeight={active || emphasize ? 700 : 500}
            color={active ? activeColor : emphasize ? emphasizeColor : inactiveColor}
            onClick={() => onNavClick(path)}
          >
            <SiteNavLinkLabel label={label} badge={badge} />
          </Button>
        );
      })}
    </HStack>
  );
}

